// 近衛騎士の槍の薙ぎの弧の見た目 (2026-10-31)。
//   駅6 の点検で、前の弧 (render.ts drawContactSmearAfterContactArc＝加算で光る線の三日月) が「コードで描いた感」の残りに数えられた。
//   作者 10-31 の答え (MvNZacftfiLDCG5aBJ4BX3・knight-arc) = C「騎士だけの槍の跡を描かせる」。メモ原文
//   「それぞれのキャラクターの武器や振っているものの材質に合わせてエフェクトを作ってほしい」。
//   → Codex が描いた槍の跡 (外の縁＝鋼の穂先の硬い刃の筋・内側＝木の柄が押しのけた灰のぶれ) を配布版の既定にする。
//   質感は絵 (public/fx/knight/knight_arc_0..3・元 = docs/research/2026-10-31-gate6-tickets/art/knight_lance_arc_sheet.png)、
//   出る・動く・消える (弧への沿わせ方・古い側から食われる・コマの進み) はコード (render.ts drawContactSmearAfterContactArt)。
// 開発版の比較: ?knightArc=line = 前の光る線の三日月 / ?knightArc=brush = 介錯の筆のぶれの絵 (作者が選ばなかった A)。
//   記録 = docs/research/2026-10-31-knight-bride-fx-art.md
export type KnightArcLook = 'art' | 'line' | 'brush'
let look: KnightArcLook = 'art'
export function setKnightArcLook(v: string | null): void { look = v === 'line' || v === 'brush' ? v : 'art' }
export function knightArcLook(): KnightArcLook { return look }

// 4コマ: 出始め → 最も長く伸びた帯 → 古い側から千切れる → 消えかけ。どのコマも左下 (尾＝構えの穂先) → 右上 (頭＝振り終わりの穂先)。
// 弦と膨らみはコマごとに絵から測った (アルファ 60 超えの点・弦 = 左下と右上の端・sag = 弦の真ん中 16% の左手側への重心 ÷ 弦の長さ)。
export const KNIGHT_ARC_CHORD: readonly { ax: number; ay: number; bx: number; by: number; sag: number }[] = [
  { ax: 0.032, ay: 0.853, bx: 0.556, by: 0.347, sag: -0.067 },
  { ax: 0.289, ay: 0.867, bx: 0.786, by: 0.124, sag: -0.145 },
  { ax: 0.269, ay: 0.870, bx: 0.742, by: 0.157, sag: -0.126 },
  { ax: 0.321, ay: 0.861, bx: 0.937, by: 0.194, sag: -0.080 },
]
const imgs: (HTMLImageElement | null)[] = [null, null, null, null]
let started = false
/** 絵の読み込みを始める (1回だけ)。Image の無い所 (Vitest) では何もしない。 */
export function preloadKnightArc(prefix = '/fx/knight/'): void {
  if (started || typeof Image === 'undefined') return
  started = true
  imgs.forEach((_, i) => {
    const img = new Image()
    img.onload = () => { imgs[i] = img }
    img.src = `${prefix}knight_arc_${i}.png`
  })
}
export function knightArcReady(): boolean { return imgs.every(i => i !== null) }
export function knightArcSprite(i: number): HTMLImageElement | null { return imgs[Math.max(0, Math.min(3, Math.floor(i)))] ?? null }

/** 振りの進み p (0..1・1 で振り切り) と消え fade (1→0) から使うコマ。振る間は 0→1、振り切った後は 1→2→3 と千切れる。 */
export function knightArcFrame(p: number, fade: number): number {
  if (p < 1) return p < 0.45 ? 0 : 1
  return fade > 0.66 ? 1 : fade > 0.33 ? 2 : 3
}
